import { HttpErrorResponse } from '@angular/common/http';

export const getErrorMessage = (error: HttpErrorResponse | any): string =>
  error.message.errorMessage ||
  error.message.errorDescription ||
  error.error?.errorMessage ||
  (error.message.error && error.message.error[0]) ||
  error.message ||
  error.message.errors[0].message;
